import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { path, identity, compose, pathOr } from 'ramda'
import { Icon as AntIcon } from 'antd'
import * as FaIcons from 'react-icons/fa'
import withStyle, { IconMoon } from './Icon.style.js'
import {
  isAntdIcon,
  isIconMoon,
  isChecIcon,
  isFontAwesomeIcon,
} from './iconTypes'
import IconMoonDictionary from './selection.js'

import 'styles/Icon.css'

/** TODO :: The current logic is not handling svgs with multipaths
 *  Add logic to handle multipath svgs
 * */

function renderPaths(icon) {
  const paths = path(['icon', 'paths'], IconMoonDictionary[icon])
  const attrs = path(['icon', 'attrs'], IconMoonDictionary[icon])

  if (paths.length < 2) {
    return <path d={path(['icon', 'paths'], IconMoonDictionary[icon])} />
  }

  return paths.map((p, index) => <path d={p} key={p} {...attrs[index]} />)
}
export function Icon({
  className,
  height,
  width,
  color,
  style,
  viewBox,
  disabled,
  fill,
  hoverFill,
  hoverColor,
  size,
  icon,
  rotate,
  onMouseEnter,
  onMouseLeave,
  onClick,
}) {
  const [isHovered, setIsHovered] = useState(false)

  const handleMouseEnter = () => {
    setIsHovered(true)
    onMouseEnter()
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
    onMouseLeave()
  }

  const disabledColor = '#bfbfbf'
  const styles = {
    className,
    ...(height && { height }),
    ...(width && { width }),
    ...(color && { color }),
    ...(style && { style }),
    ...(disabled && { color: disabledColor }),
  }

  const hoverStyle = {
    ...style,
    ...(hoverColor && { color: hoverColor }),
  }

  const iconClass = icon ? `chec-icon--${icon} ` : ''
  const iconClassName = `chec-icon ${iconClass}${className || ''}`

  if (isIconMoon(icon)) {
    const viewBoxWidth = pathOr(
      '1024',
      [icon, 'icon', 'width'],
      IconMoonDictionary
    )
    const viewBoxHeight = pathOr(
      '1024',
      [icon, 'icon', 'height'],
      IconMoonDictionary
    )

    return (
      <IconMoon
        size={size}
        viewBox={viewBox || `0 0 ${viewBoxWidth} ${viewBoxHeight}`}
        onClick={onClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className={iconClassName}
        fill={disabled ? disabledColor : fill}
        hoverFill={disabled ? disabledColor : hoverFill}
        showHover={onClick || hoverFill}
        style={style}
        width={width}
        height={height}
      >
        {renderPaths(icon)}
      </IconMoon>
    )
  }

  if (isAntdIcon(icon)) {
    const theme = isHovered && hoverFill ? hoverFill : fill

    return (
      <AntIcon
        theme={theme}
        onClick={onClick}
        type={icon}
        style={isHovered ? hoverStyle : style}
        rotate={rotate}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className={iconClassName}
      />
    )
  }

  if (isChecIcon(icon)) {
    return (
      <span
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        className={`chec-icon ${icon}-icon ${className || ''}`}
        onClick={onClick}
      />
    )
  }

  if (isFontAwesomeIcon(icon) && icon in FaIcons) {
    const FaIcon = FaIcons[icon]
    return <FaIcon {...styles} onClick={onClick} />
  }

  return <span className={iconClassName} style={styles} onClick={onClick} />
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  fill: PropTypes.string,
  hoverFill: PropTypes.string,
  style: PropTypes.object,
  rotate: PropTypes.number,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onHover: PropTypes.func,
  // 'large' 22x22 'medium' 18x18 'small' 16x16 'x-small' 12x12
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showHover: PropTypes.bool,
  viewBox: PropTypes.string,
}

Icon.defaultProps = {
  disabled: false,
  onMouseEnter: identity,
  onMouseLeave: identity,
  onHover: identity,
  className: '',
  color: '',
  size: '100%',
}

export default compose(withStyle)(Icon)
